import { default as scrollCards } from "./modules/_scroll-cards"
import { default as desktopHeader } from "./modules/_desktop-header"
import { default as mobileHeader } from "./modules/_mobile-header"
import { default as readMore } from "./modules/_read-more"

(() => {

    mobileHeader.init()
    desktopHeader.init()
    scrollCards.init()
    readMore.init()

})();